import client from '../client'

export const getCardDetailsKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/GetCardDetails`

export async function getCardDetails({ userId, returnVerifiedDealer }) {
  const params = new URLSearchParams({ userId, returnVerifiedDealer })

  return client(`${getCardDetailsKey}?${params}`)
}
